import Mustache from 'mustache';
import { displaySuccessFeedbackMessage, displayInfoFeedbackMessage, displayErrorFeedbackMessage, getTranslation,
    stringToHTML, debounce } from './utilities';
import CartClient from './clients/CartClient';
import ShoppinglistTablesOverlay from './shoppinglists-tables-overlay';
import createAboPaths from './abo-paths';

class Cart
{
    constructor()
    {
        this.cartClient = new CartClient();
        this.shoppinglistTablesOverlay = new ShoppinglistTablesOverlay();

        this.table = undefined;
        this.filteredProductsCount = null;
        this.filteredProducts = {};
        this.selectedRows = {};

        this.itemElementTemplate = document.querySelector('#basketItemElementTemplate').innerHTML;
        this.summaryTemplate = document.querySelector('#basketSummaryTemplate').innerHTML;
        this.voucherCodeTemplate = document.querySelector('#basketVoucherCodeTemplate').innerHTML;
        this.fixedPriceOfferExpiryTemplate = document.querySelector('#fixedPriceOfferExpiryTemplate').innerHTML;

        this.selector = '.js-basket';
        this.itemSelector = '.js-basket__item';
        this.deleteButtonSelector = '.js-basket__delete-list';
        this.addToCartButtonSelector = '.js-basket__add-to-cart';
        this.quantitySelector = '.js-basket__quantity';
        this.quantityToSellingUnitSelector = '.js-quantity-to-selling-unit';
        this.summarySelector = '.js-basket__summary';
        this.summarySelectionInfoSelector = '.js-basket__selection-info';
        this.summaryContentSelector = '.js-basket__summary-content';
        this.actionsWrapperSelector = '.js-basket__actions-wrapper';
        this.fixedPriceOfferAndShoppinglistAndSummaryWrapperSelector =
            '.js-basket__fixed-price-offer-and-shoppinglist-and-summary-wrapper';
        this.fixedPriceOfferAndShoppinglistWrapperSelector = '.js-basket__fixed-price-offer-and-shoppinglist-wrapper';
        this.shoppinglistWrapperSelector = '.js-basket__shoppinglist-wrapper';
        this.fixedPriceOfferWrapperSelector = '.js-basket__fixed-price-offer-wrapper';
        this.actionsShoppinglistSelector = '.js-basket__actions--shoppinglist';
        this.actionsCartSelector = '.js-basket__actions--cart';
        this.checkoutButtonSelector = '.js-basket__checkout-button';
        this.voucherInputSelector = '.js-voucher-input';
        this.voucherButtonSelector = '.js-voucher-button';
        this.selectAllButtonSelector = '.js-basket__select_all--button';

        this.filters = [];
        this.urlSuffix = '';

        this.containsBulkyProducts = false;
        this.containsMarketplaceProducts = false;
        this.containsUnavailableProducts = false;
        this.containsUnknownProducts = false;

        this.filteredItemsFetched = false;

        this.bulkyFeedbackmessageShown = false;
        this.marketplaceFeedbackmessageShown = false;
        this.unknownFeedbackmessageShown = false;

        this.checkboxContainerBulky = document.querySelector('.js-checkbox--bulky');
        this.checkboxContainerMarketplace = document.querySelector('.js-checkbox--marketplace');
        this.checkboxContainerAvailability = document.querySelector('.js-checkbox--availability');
        this.checkboxContainerUnknownProducts = document.querySelector('.js-checkbox--unknown');
        this.checkboxBulky = document.querySelector('.js-checkbox--bulky input');
        this.checkboxMarketplace = document.querySelector('.js-checkbox--marketplace input');
        this.checkboxAvailability = document.querySelector('.js-checkbox--availability input');
        this.checkboxUnknown = document.querySelector('.js-checkbox--unknown input');

        this.isFixedPriceOffer = document.querySelector('.js-fixed-price-offer') ? true : false;

        this.isShoppinglistTablesOverlayInitialized = false;
    }

    init()
    {
        let isEmpty;

        this.table = $(this.selector).DataTable({
            ajax: {
                url: this.cartClient.uri + '/items',
                data: function(data)
                {
                    let dataset = {
                        skip: data.start,
                        take: data.length,
                    };

                    dataset.sort = this.formatOrder(this, data.order);

                    return dataset;
                }.bind(this),
                dataSrc: (json) =>
                {
                    let data = json.response.productItems.map((productItem) =>
                    {
                        const originalSrc = productItem.productImageUrl.trim();
                        const targetSrc = originalSrc.replace('product-main-image', 'product-list-image-thumbnail');

                        const aboPaths = createAboPaths(targetSrc);

                        productItem.productImageUrl = aboPaths.original;
                        productItem.productImageUrlAvif = aboPaths.avifImage + ', ' + aboPaths.avifRetinaImage + ' 2x';
                        productItem.productImageUrlWebp = aboPaths.webPImage + ', ' + aboPaths.webPRetinaImage + ' 2x';
                        productItem.productImageUrlJpeg = aboPaths.jpgImage + ', ' + aboPaths.jpgRetinaImage + ' 2x';

                        productItem.noveltyFlag = productItem.noveltyFlag !== '0';
                        productItem.bestsellerFlag = productItem.bestsellerFlag !== 0;
                        productItem.expiringProductFlag = productItem.expiringProductFlag !== 0;
                        productItem.promotionalPackingFlag = productItem.promotionalPackingFlag === 0;
                        productItem.bargainProductFlag = productItem.bargainProductFlag !== 0;
                        productItem.posProductFlag = productItem.posProductFlag !== '0';
                        productItem.discountBlock = productItem.discountBlock === 'true';

                        productItem.isAvailable = false;
                        productItem.isUpcoming = false;

                        if (productItem.availability === 0)
                        {
                            productItem.isOutOfStock = true;
                        }
                        else if (productItem.availability === 1)
                        {
                            productItem.isAvailable = true;
                        }
                        else if (productItem.availability === 2)
                        {
                            productItem.isUpcoming = true;
                        }

                        productItem.isAdvertisingMaterial = productItem.productType == 'advertisingMaterial';

                        return productItem;
                    });

                    this.filteredProductsCount = json.recordsFiltered;
                    this.filteredProducts = json.response.productItems;

                    this.containsUnavailableProducts = json.notAvailableProductItemCount >= 1;
                    this.containsBulkyProducts = json.checkoutDataTags.includes('bulkyGoodsFlag');
                    this.containsMarketplaceProducts = json.checkoutDataTags.includes('marketplaceNotAllowedFlag');
                    this.containsUnknownProducts = json.checkoutDataTags.includes('unknownProductFlag');

                    return data;
                }
            },
            dom: 'l\
				f\
				r\
				<"basket-list-table__scroll table--scroll-mobile"t>\
				<"' + this.fixedPriceOfferAndShoppinglistAndSummaryWrapperSelector
                + ' basket-list__fixed-price-offer-and-shoppinglist-and-summary-wrapper"\
				<"' + this.fixedPriceOfferAndShoppinglistWrapperSelector
                + ' basket-list__fixed-price-offer-and-shoppinglist-wrapper"\
				<"' + this.fixedPriceOfferWrapperSelector + ' basket-list__fixed-price-offer-wrapper">\
				<"' + this.shoppinglistWrapperSelector + ' basket-list__shoppinglist-wrapper">>\
				<"' + this.summarySelector + ' list-information">>\
				<"' + this.actionsWrapperSelector + ' basket-list__actions-wrapper">\
				p\
				i',
            pageLength: 40,
            searching: false,
            lengthChange: false,
            language: this.datatableTexts(),
            serverSide: true,
            processing: true,
            rowId: 'productNumber',
            info: true,
            select: {
                style: 'multi',
                selector: 'td:first-child'
            },
            columnDefs: [
                {
                    targets: [0, 1, 2, 3, 4, 5, 6, 7],
                    orderable: false
                },
                {
                    width: '5%',
                    targets: 0,
                    className: 'js-basket__select_all--wrapper basket-list__select select-checkbox',
                    visible: !this.isFixedPriceOffer,
                    render: function(data, _type, row)
                    {
                        return Mustache.render(this.itemElementTemplate, {
                            basketListItem: row,
                            selectColumn: true
                        });
                    }.bind(this)
                },
                {
                    // Hidden column to sort for product number
                    // Sort criteria must be mapped to a column
                    // See matchOrderIdWithColumnName(orderId)
                    targets: 1,
                    visible: false,
                    render: function()
                    {
                        return Mustache.render(this.itemElementTemplate, {
                            productNumberColumn: true
                        });
                    }.bind(this)
                },
                {
                    data: null,
                    width: this.isFixedPriceOffer ? '42%' : '37%',
                    targets: 2,
                    className: 'basket-list__description',
                    render: function(data, type, row)
                    {
                        return Mustache.render(this.itemElementTemplate, {
                            basketListItem: row,
                            productDetailsColumn: true
                        });
                    }.bind(this),
                    createdCell: function(td, cellData, rowData)
                    {
                        let $availabilityIcon = $(td).find('i.fa-circle');

                        if (rowData.isOutOfStock)
                        {
                            $availabilityIcon.addClass('out-of-stock');
                        }
                        else if (rowData.isAvailable)
                        {
                            $availabilityIcon.addClass('in-stock');
                        }
                        else if (rowData.isPreorder)
                        {
                            $availabilityIcon.addClass('out-of-stock');
                        }
                    }
                },
                {
                    width: '15%',
                    targets: 3,
                    className: 'basket-list__lp-sp',
                    render: function(data, type, row)
                    {
                        return Mustache.render(this.itemElementTemplate, {
                            basketListItem: row,
                            undiscountedPriceColumn: !row.productUnknown
                        });
                    }.bind(this)
                },
                {
                    width: '10%',
                    targets: 4,
                    className: 'basket-list__price',
                    render: function(data, type, row)
                    {
                        return Mustache.render(this.itemElementTemplate, {
                            basketListItem: row,
                            discountedPriceColumn: !row.productUnknown
                        });
                    }.bind(this)
                },
                {
                    width: '10%',
                    targets: 5,
                    className: 'basket-list__quantity tooltip-wrapper',
                    render: function(data, type, row)
                    {
                        return Mustache.render(this.itemElementTemplate, {
                            basketListItem: row,
                            quantityColumn: !row.productUnknown,
                            isFixedPriceOffer: this.isFixedPriceOffer
                        });
                    }.bind(this)
                },
                {
                    width: '13%',
                    targets: 6,
                    className: 'basket-list__sellingunit',
                    render: function(data, type, row)
                    {
                        return Mustache.render(this.itemElementTemplate, {
                            basketListItem: row,
                            sellingUnitColumn: !row.productUnknown,
                            isFixedPriceOffer: this.isFixedPriceOffer
                        });
                    }.bind(this)
                },
                {
                    width: '10%',
                    data: 'subtotalPrice',
                    targets: 7,
                    className: 'basket-list__total',
                    render: function(data, type, row)
                    {
                        return Mustache.render(this.itemElementTemplate, {
                            basketListItem: row,
                            subtotalPriceColumn: !row.productUnknown
                        });
                    }.bind(this)
                },
            ],
            drawCallback: function()
            {
                isEmpty = this.table.data().count() === 0;
                let $emptyText = $('.dataTables_empty');

                if (isEmpty)
                {
                    $('#basket_wrapper > div').hide();
                    $('#basket_wrapper').append($emptyText);
                    $('.js-basket__sort').addClass('hidden');
                }
                else
                {
                    $('#basket_wrapper > div').show();
                    $emptyText.remove();
                    $('.js-basket__sort').removeClass('hidden');

                    if (!this.isFixedPriceOffer)
                    {
                        if (this.selectedRows
                            && Object.keys(this.selectedRows).length > 0)
                        {
                            Object.keys(this.selectedRows)
                                .forEach((productNumber) =>
                                {
                                    this.table.row('#' + productNumber)
                                        .select();
                                });
                        }
                        else
                        {
                            $('.js-basket__select_all--wrapper')
                                .removeClass('selected');
                        }
                        this.handleSelectAllButtonView();
                    }
                    else
                    {
                        displayInfoFeedbackMessage(
                            'feedback.basket.fixed.price.offer.info',
                            '',
                            true
                        );
                    }

                    if (!this.filteredItemsFetched)
                    {
                        this.prepareFilters();
                    }

                    this.fetchSummaryData();
                }
                this.handleFlags();
                this.initEvents();
            }.bind(this),
            initComplete: function()
            {
                let actionsWrapper = document.querySelector(this.actionsWrapperSelector);
                let fixedPriceOfferWrapper = document.querySelector(this.fixedPriceOfferWrapperSelector);
                let shoppinglistWrapper = document.querySelector(this.shoppinglistWrapperSelector);

                actionsWrapper.append(
                    this.table.buttons('cart', null).container()[0]
                );

                if (this.isFixedPriceOffer)
                {
                    fixedPriceOfferWrapper.append(
                        this.table.buttons('fixedPriceOffer', null).container()[0]
                    );
                    document.querySelector('.basket-list__actions--fixed-price-offer').prepend(
                        stringToHTML(Mustache.render(this.fixedPriceOfferExpiryTemplate))
                    );
                }
                else
                {
                    shoppinglistWrapper.append(
                        this.table.buttons('shoppinglist', null)
                            .container()[0]
                    );

                    this.table.buttons('shoppinglist', [0, 1]).disable();

                    document.querySelector('.basket-list__actions--cart')
                        .prepend(
                            stringToHTML(Mustache.render(this.voucherCodeTemplate))
                        );

                    document.querySelector(this.voucherInputSelector)
                        .addEventListener('input', (event) =>
                        {
                            if (event.target.value.trim().length)
                            {
                                document.querySelector(this.voucherButtonSelector)
                                    .classList
                                    .remove('disabled');
                            }
                            else
                            {
                                document.querySelector(this.voucherButtonSelector)
                                    .classList
                                    .add('disabled');
                            }
                        });
                }

                if (!isEmpty)
                {
                    this.createSortSelection(this.table);
                }
                $('body').trigger(orion.constants.EventProductListReloaded);
            }.bind(this),
            createdRow: function(row)
            {
                let $row = $(row);

                $row.addClass('basket-list__item js-basket__item');
            }
        });

        new $.fn.dataTable.Buttons(this.table, {
            name: 'shoppinglist',
            dom: {
                container: {
                    className: 'basket-list__actions--shoppinglist'
                },
                button: {
                    className: ''
                }
            },
            buttons: [
                {
                    text: '<i class="fa-regular fa-trash-can"></i>'
                        + '<span>'
                        + getTranslation('content.cartitemlist.delete')
                        + '</span>',
                    className: 'button secondary shoppinglists-icon-wrapper',
                    action: function()
                    {
                        let selectedItems = this.selectedRows;

                        $('.js-basket-delete-products-count').text(Object.keys(selectedItems).length);

                        if (Object.keys(selectedItems).length > 1)
                        {
                            $('.js-overlay-delete-basket-products-singular').addClass('hidden');
                            $('.js-overlay-delete-basket-products-plural').removeClass('hidden');
                        }
                        else
                        {
                            $('.js-overlay-delete-basket-products-singular').removeClass('hidden');
                            $('.js-overlay-delete-basket-products-plural').addClass('hidden');
                        }

                        this.showOverlay($('#overlay-delete-basket-products'), selectedItems);
                    }.bind(this)
                },
                {
                    text:
                        getTranslation('form.submit~shoppinglist.add~cart'),
                    className: 'button secondary shoppinglists-icon-wrapper js-basket__to-shoppinglist ' +
                        'js-gtm-shoppinglist-basket__overlay--open',
                    action: function()
                    {
                        this.shoppinglistTablesOverlay.initOverlay(this.selectedRows);
                    }.bind(this)
                },
            ]
        });

        new $.fn.dataTable.Buttons(this.table, {
            name: 'cart',
            dom: {
                container: {
                    className: 'basket-list__actions--cart'
                },
                button: {
                    className: ''
                }
            },
            buttons: [
                {
                    tag: 'a',
                    text: getTranslation('form.submit~checkout'),
                    className: 'button buy--button add-to-cart js-basket__checkout-button mb--base-top',
                    attr: {
                        href: getTranslation('url.checkout-address')
                    },
                    action: function(_e, _dt, $node)
                    {
                        window.location = $node.attr('href');
                    }.bind(this)
                },
                {
                    text: getTranslation('form.download-cart-as-csv'),
                    className: 'button secondary js-download-cart-as-csv download-cart-as-csv',
                },
            ]
        });

        new $.fn.dataTable.Buttons(this.table, {
            name: 'fixedPriceOffer',
            dom: {
                container: {
                    className: 'basket-list__actions--fixed-price-offer'
                },
                button: {
                    className: ''
                }
            },
            buttons: [
                {
                    text: getTranslation('form.cancel.fixed.price.offer'),
                    className: 'button tertiary ' +
                        'js-basket__cancel-fixed-price-offer',
                    action: function()
                    {
                        this.handleCancelFixedPriceOffer();
                    }.bind(this)
                },
            ]
        });

        this.shoppinglistTablesOverlay.init();
        this.initStaticEvents();
        this.showFeedbackMessageOrderInBasket();
    }

    showFeedbackMessageOrderInBasket()
    {
        let url = window.location.href;

        if (url.includes('order-added-basket'))
        {
            displaySuccessFeedbackMessage(
                'feedback.basket.reorder.added.ok',
                '',
                true
            );
        }
        else if (url.includes('order-replace-basket'))
        {
            displaySuccessFeedbackMessage(
                'feedback.basket.reorder.replaced.ok',
                '',
                true
            );
        }
    }

    initStaticEvents()
    {
        $('body').on(orion.constants.EventCartProductCreated, () =>
        {
            this.table.ajax.reload();
        });
    }

    createSortSelection(table)
    {
        let filterSection = document.createElement('div');
        let sortSelection = document.createElement('select');
        let sortPlaceholder = document.createElement('option');

        filterSection.classList.add('basket__sort', 'js-basket__sort', 'select-button-container');

        sortPlaceholder.value = '';
        sortPlaceholder.text = getTranslation('content.cartitemlist.sort.recent');
        sortPlaceholder.selected;
        sortPlaceholder.disabled;
        sortSelection.appendChild(sortPlaceholder);

        let { 0: columns } = table.columns();

        for (let i = 1; i < columns.length; i++)
        {
            if (i === 6)
            {
                continue;
            }

            let optionAscending = document.createElement('option');
            let optionDescending = document.createElement('option');

            optionAscending.value = columns[i];
            optionAscending.text = getTranslation('content.cartitemlist.header.col.' + i) + ' '
                + getTranslation('content.cartitemlist.sort.ascending');
            sortSelection.appendChild(optionAscending);

            optionDescending.value = columns[i] * -1;
            optionDescending.text = getTranslation('content.cartitemlist.header.col.' + i) + ' '
                + getTranslation('content.cartitemlist.sort.descending');
            sortSelection.appendChild(optionDescending);
        }

        filterSection.append(sortSelection);
        document.querySelector('.js-basket_filter_sorting_section').append(filterSection);

        sortSelection.addEventListener('change', function()
        {
            if (this.value > 0)
            {
                table.order([this.value, 'asc']).draw();
            }
            else if (this.value < 0)
            {
                table.order([this.value * -1, 'desc']).draw();
            }
            else
            {
                table.order([0, 'asc']).draw();
            }
        });
    }

    prepareFilters()
    {
        let filterParam = this.filters.join('&').toString();
        let limitParam = '&take=' + this.filteredProductsCount.toString();

        this.cartClient.fetchItemsWithParams(filterParam + limitParam)
            .then((response) => response.json())
            .then((json) =>
            {
                this.containsBulkyProducts = json.checkoutDataTags.includes('bulkyGoodsFlag');
                this.containsMarketplaceProducts = json.checkoutDataTags.includes('marketplaceNotAllowedFlag');
                this.containsUnavailableProducts = json.notAvailableProductItemCount >= 1;
                this.containsUnknownProducts = json.checkoutDataTags.includes('unknownProductFlag');

                this.updateFilters();

                if (this.filteredItemsFetched)
                {
                    this.handleFilters();
                }

                this.filteredItemsFetched = true;
            });
    }

    handleSelectAllButtonView()
    {
        let isAllSelected = false;

        if (this.filteredProductsCount <= Object.keys(this.selectedRows).length)
        {
            for (let i = 0; i < this.filteredProducts.length; i++)
            {
                if (this.filteredProducts[i].productNumber in this.selectedRows)
                {
                    isAllSelected = true;
                }
                else
                {
                    isAllSelected = false;
                    break;
                }
            }
        }

        if (isAllSelected)
        {
            document.querySelector('th.js-basket__select_all--wrapper').classList.add('selected');
        }
        else
        {
            document.querySelector('th.js-basket__select_all--wrapper').classList.remove('selected');
        }
    }

    handleFlags()
    {
        if (this.containsBulkyProducts)
        {
            this.checkboxContainerBulky.classList.remove('hidden');
            if (!this.bulkyFeedbackmessageShown)
            {
                displayInfoFeedbackMessage(
                    'feedback.basket.bulky-goods.text',
                    'feedback.basket.bulky-goods.title',
                    true
                );
                this.bulkyFeedbackmessageShown = true;
            }
        }
        else
        {
            this.checkboxContainerBulky.classList.add('hidden');
        }

        if (this.containsMarketplaceProducts)
        {
            this.checkboxContainerMarketplace.classList.remove('hidden');
            if (!this.marketplaceFeedbackmessageShown)
            {
                displayInfoFeedbackMessage(
                    'feedback.basket.market.place.not.allowed.text',
                    'feedback.basket.market.place.not.allowed.title',
                    true
                );
                this.marketplaceFeedbackmessageShown = true;
            }
        }
        else
        {
            this.checkboxContainerMarketplace.classList.add('hidden');
        }

        if (this.containsUnavailableProducts)
        {
            this.checkboxContainerAvailability.classList.remove('hidden');
        }
        else
        {
            this.checkboxContainerAvailability.classList.add('hidden');
        }
        if (this.containsUnknownProducts)
        {
            this.checkboxContainerUnknownProducts.classList.remove('hidden');
            if (!this.unknownFeedbackmessageShown)
            {
                displayErrorFeedbackMessage(
                    'feedback.basket.unknown.products.text',
                    'feedback.basket.unknown.products.title',
                    true,
                );
                this.unknownFeedbackmessageShown = true;
            }
        }
        else
        {
            this.checkboxContainerUnknownProducts.classList.add('hidden');
        }
    }

    handleFilters()
    {
        this.filters = [];

        // Workaround until a viable solution has been found, for combining these filters
        this.checkboxContainerBulky.classList.remove('disabled');
        this.checkboxContainerMarketplace.classList.remove('disabled');
        this.checkboxContainerAvailability.classList.remove('disabled');
        this.checkboxContainerUnknownProducts.classList.remove('disabled');

        if (this.checkboxBulky.checked)
        {
            this.checkboxContainerMarketplace.classList.add('disabled');
            this.checkboxContainerAvailability.classList.add('disabled');
            this.checkboxContainerUnknownProducts.classList.add('disabled');
            this.filters.push('filterCheckoutDataTagsBy[]=bulkyGoodsFlag');
        }
        if (this.checkboxMarketplace.checked)
        {
            this.checkboxContainerBulky.classList.add('disabled');
            this.checkboxContainerAvailability.classList.add('disabled');
            this.checkboxContainerUnknownProducts.classList.add('disabled');
            this.filters.push('filterCheckoutDataTagsBy[]=marketplaceNotAllowedFlag');
        }
        if (this.checkboxAvailability.checked)
        {
            this.checkboxContainerBulky.classList.add('disabled');
            this.checkboxContainerMarketplace.classList.add('disabled');
            this.checkboxContainerUnknownProducts.classList.add('disabled');
            this.filters.push('filterBy[]=notAvailable');
        }
        if (this.checkboxUnknown.checked)
        {
            this.checkboxContainerBulky.classList.add('disabled');
            this.checkboxContainerMarketplace.classList.add('disabled');
            this.checkboxContainerAvailability.classList.add('disabled');
            this.filters.push('filterCheckoutDataTagsBy[]=unknownProductFlag');
        }

        if (this.filters.length >= 1)
        {
            this.urlSuffix = '?' + this.filters.join('&');
        }
        else
        {
            this.urlSuffix = '';
        }

        this.table.ajax.url(this.cartClient.uri + '/items' + this.urlSuffix).load();
    }

    resetFilters()
    {
        this.filters = [];

        this.checkboxBulky.checked = false;
        this.checkboxMarketplace.checked = false;
        this.checkboxAvailability.checked = false;
        this.checkboxUnknown.checked = false;
        this.urlSuffix = '';

        this.checkboxContainerBulky.classList.remove('disabled');
        this.checkboxContainerMarketplace.classList.remove('disabled');
        this.checkboxContainerAvailability.classList.remove('disabled');
        this.checkboxContainerUnknownProducts.classList.remove('disabled');

        this.table.ajax.url(this.cartClient.uri + '/items' + this.urlSuffix).load();
    }

    updateFilters()
    {
        if (!this.containsBulkyProducts)
        {
            this.checkboxBulky.checked = false;
        }

        if (!this.containsMarketplaceProducts)
        {
            this.checkboxMarketplace.checked = false;
        }

        if (!this.containsUnavailableProducts)
        {
            this.checkboxAvailability.checked = false;
        }
        if (!this.containsUnknownProducts)
        {
            this.checkboxUnknown.checked = false;
        }
    }

    handleCancelFixedPriceOffer()
    {
        this.showOverlay($('#overlay-cart-cancel-fixed-price-offer'));
    }

    handleDeleteSelectionClick(selectedData)
    {
        let items = this.productNumbersArrayToBodyData(selectedData);

        let promise = this.cartClient.deleteItems(items);

        this.handleRequestPromise(
            promise,
            'content.cart.delete.choices.ok',
            '',
            false,
            this.table,
            () =>
            {
                this.selectedRows = {};

                this.table.buttons('shoppinglist', [0, 1]).disable();

                this.prepareFilters();
            }
        );
    }

    initEvents()
    {
        let self = this;

        if (!this.isFixedPriceOffer)
        {
            $(this.selectAllButtonSelector).off('click');
            $(this.selectAllButtonSelector).on('click', function()
            {
                let filterParam = self.filters.join('&').toString();
                let limitParam = '&take=' + self.filteredProductsCount.toString();

                if (!$('.js-basket__select_all--wrapper').hasClass('selected'))
                {
                    self.cartClient.fetchItemsWithParams(filterParam + limitParam)
                        .then((response) => response.json())
                        .then((json) =>
                        {
                            let body = {};

                            for (let i = 0; i < json.response.productItems.length; i++)
                            {
                                body[json.response.productItems[i].productNumber] =
                                    json.response.productItems[i].quantity;
                            }

                            this.selectedRows = self.selectedRows = body;

                            self.table.rows().select();
                            self.table.draw(false);
                        });
                    $('.js-basket__select_all--wrapper').addClass('selected');
                }
                else
                {
                    self.cartClient.fetchItemsWithParams(filterParam + limitParam)
                        .then((response) => response.json())
                        .then((json) =>
                        {
                            for (let i = 0; i < json.response.productItems.length; i++)
                            {
                                delete self.selectedRows[json.response.productItems[i].productNumber];
                            }

                            this.selectedRows = self.selectedRows;

                            self.table.rows().deselect();
                            self.table.draw(false);
                        });
                    $('.js-basket__select_all--wrapper').removeClass('selected');
                }
            });

            $(this.quantitySelector).off('input');
            $(this.quantitySelector).on('input', event =>
            {
                if (Number.parseInt(event.target.value) <= 0)
                {
                    event.target.value = 1;
                }
            });

            $(this.quantitySelector).off('blur');
            $(this.quantitySelector).on('blur', event =>
            {
                if (event.target.value === '')
                {
                    event.target.value = 1;
                }
            });

            $(this.quantitySelector).off('change');
            $(this.quantitySelector).on('change', debounce((event) =>
            {
                let $tr = $(event.target).parents('tr');
                let row = self.table.row($tr);
                let data = row.data();

                let $qtyInput = $(event.target);

                let { productNumber } = data;
                let quantity = Number.parseInt($qtyInput.val());

                this.handleQtyChange(productNumber, quantity);
            }));

            $(this.quantityToSellingUnitSelector).off('click');
            $(this.quantityToSellingUnitSelector).on('click', function()
            {
                let $tr = $(this).parents('tr');
                let row = self.table.row($tr);
                let data = row.data();

                let { productNumber } = data;
                let sellingUnit = Number.parseInt(data.sellingUnit);

                let quantity = Number.parseInt($tr.find('.js-basket__quantity').val());

                let newQty = sellingUnit - (quantity % sellingUnit) + quantity;

                self.handleQtyChange(productNumber, newQty);
            });

            if (!this.isFixedPriceOffer)
            {
                this.table.on('select', (e, dt, type, indexes) =>
                {
                    if (!$(e.target).is('.js-basket__quantity'))
                    {
                        let { 0: productNumber } = self.table.rows(indexes).data().pluck('productNumber');

                        if (!(productNumber in this.selectedRows))
                        {
                            let quantity = self.getDataValueForRow(productNumber, 'quantity');

                            self.selectedRows[productNumber] = quantity;
                        }

                        if (Object.keys(self.selectedRows).length > 0)
                        {
                            this.table.buttons('shoppinglist', [0, 1]).enable();
                        }

                        this.handleSelectAllButtonView();
                    }
                });

                this.table.on('deselect', (e, dt, type, indexes) =>
                {
                    let { 0: productNumber } = self.table.rows(indexes).data().pluck('productNumber');

                    delete self.selectedRows[productNumber];

                    if (Object.keys(self.selectedRows).length === 0)
                    {
                        this.table.buttons('shoppinglist', [0, 1]).disable();
                    }

                    document.querySelector('th.js-basket__select_all--wrapper').classList.remove('selected');
                });
            }
        }

        $(this.checkboxBulky).off('click');
        $(this.checkboxBulky).on('click', () =>
        {
            self.handleFilters();
        });

        $(this.checkboxMarketplace).off('click');
        $(this.checkboxMarketplace).on('click', () =>
        {
            self.handleFilters();
        });

        $(this.checkboxAvailability).off('click');
        $(this.checkboxAvailability).on('click', () =>
        {
            self.handleFilters();
        });

        $(this.checkboxUnknown).off('click');
        $(this.checkboxUnknown).on('click', () =>
        {
            self.handleFilters();
        });

        if (!this.isShoppinglistTablesOverlayInitialized)
        {
            document.addEventListener('products-moved-to-shoppinglist', () =>
            {
                this.handleDeleteSelectionClick(this.selectedRows);
            });

            this.isShoppinglistTablesOverlayInitialized = true;
        }
    }

    getDataValueForRow(rowId, key)
    {
        let data = this.table.row('#' + rowId).data();

        if (Object.prototype.hasOwnProperty.call(data, key))
        {
            return data[key];
        }
    }

    fetchSummaryData()
    {
        this.cartClient.fetchSummary()
            .then((response) => response.json())
            .then((data) =>
            {
                data.response.cart.hasSavings = false;

                if (data.totalMoneySavedString != '0,00 €')
                {
                    data.response.cart.hasSavings = true;
                }

                this.updateSummary(data.response.cart);
                this.updateCheckoutButton(data.response.cart.isMinimumOrderValueReached);
            });
    }

    updateSummary(data)
    {
        let summaryWrapper = document.querySelector(this.summarySelector);

        let summaryElement = summaryWrapper.querySelector(this.summaryContentSelector);

        if (summaryElement !== null)
        {
            summaryElement.remove();
        }

        let summary = Mustache.render(this.summaryTemplate, {
            basketSummaryData: data
        });

        let summaryHTML = stringToHTML(summary);

        summaryWrapper.append(summaryHTML);

        if (!this.isFixedPriceOffer)
        {
            this.table.buttons('selection', null).container()
                .prependTo(document.querySelector(this.summarySelectionInfoSelector));
        }
    }

    updateCheckoutButton(isMinimumOrderValueReached)
    {
        let existingMinimumOrderDiv = document.querySelector('.js-minimum-order-container');

        if (!isMinimumOrderValueReached)
        {
            if (!existingMinimumOrderDiv)
            {
                document.querySelector(this.checkoutButtonSelector).classList.add('disabled');
                let minimumOrderDiv = document.createElement('div');
                minimumOrderDiv.className = 'small error-color js-minimum-order-container';
                minimumOrderDiv.innerHTML = $('meta[name="content.minimum.order.value.not.reached"]').attr('content');
                let checkoutButton = document.querySelector(this.checkoutButtonSelector);
                checkoutButton.parentNode.insertBefore(minimumOrderDiv, checkoutButton.nextSibling);

                return minimumOrderDiv;
            }
        }
        else
        {
            document.querySelector(this.checkoutButtonSelector).classList.remove('disabled');
            if (existingMinimumOrderDiv)
            {
                existingMinimumOrderDiv.remove();
            }
        }
    }

    handleQtyChange(productNumber, quantity)
    {
        let data = {
            'productItems': [
                {
                    'productNumber': productNumber.toString(),
                    'quantity': quantity
                }
            ]
        };

        this.handleRequestPromise(
            this.cartClient.update(data),
            '',
            '',
            true,
        );
    }

    datatableTexts()
    {
        return {
            'paginate': {
                'previous': '<i class="fa-regular fa-chevron-left"></i>',
                'next': '<i class="fa-regular fa-chevron-right"></i>',
            },
            'processing': getTranslation('content.cartitemlist.processing'),
            'loadingRecords': getTranslation('content.cartitemlist.loading'),
            'info': getTranslation('content.cartitemlist.info.entries'),
            'infoEmpty': getTranslation('content.cartitemlist.info.entries.empty'),
            'infoFiltered': getTranslation('content.cartitemlist.info.entries.filtered'),
            'emptyTable': getTranslation('content.cartitemlist.info.list.empty'),
            'select': {
                'rows': {
                    _: '(%d) '
						+ getTranslation('content.cartitemlist.info.selected.article'),
                },
            }
        };
    }

    formatOrder(self, order)
    {
        $(order).each(function(k)
        {
            order[k].field = self.matchOrderIdWithColumnName(order[k].column);
        });

        return order;
    }

    matchOrderIdWithColumnName(orderId)
    {
        switch (orderId)
        {
        case 1:
            return 'productNumber';
        case 2:
            return 'productName';
        case 3:
            return 'undiscountedPrice';
        case 4:
            return 'discountedPrice';
        case 5:
            return 'quantity';
        case 6:
            return 'sellingUnit';
        case 7:
            return 'subtotalPrice';
        default:
            return null;
        }
    }

    productNumbersArrayToBodyData(products, withQty = false)
    {
        let productItems = [];

        for (let productNumber in products)
        {
            let obj = {
                productNumber: productNumber
            };

            if (withQty)
            {
                obj.quantity = products[productNumber];
            }

            productItems.push(obj);
        }

        return {
            'productItems': productItems
        };
    }

    /**
	 * @param promise {Promise<Response>}
	 * @param successMessage {string}
	 * @param errorMessage {string}
	 * @param refreshAfterSuccess {boolean}
	 * @param tableRef
	 * @param cb
	 */
    handleRequestPromise(
        promise,
        successMessage,
        errorMessage = '',
        refreshAfterSuccess = false,
        tableRef = this.table,
        cb = null
    )
    {
        promise
            .then(resp =>
            {
                if (resp.ok)
                {
                    this.handleSuccessfulRequests(successMessage, refreshAfterSuccess, tableRef);
                    $('body').trigger(orion.constants.EventCartProductUpdated);

                    if (typeof cb === 'function')
                    {
                        cb();
                    }
                }
                else
                {
                    this.handleErrorRequests(errorMessage);
                }
            })
            .catch(function(error)
            {
                this.handleErrorRequests(error);
            });
    }

    /**
	 * @param successMessage {string}
	 * @param refreshAfter
	 * @param tableRef
	 */
    handleSuccessfulRequests(successMessage, refreshAfter, tableRef)
    {
        if (successMessage !== '')
        {
            displaySuccessFeedbackMessage(successMessage, '', true);
        }
        if (refreshAfter)
        {
            tableRef.ajax.reload(() =>
            {
                this.initEvents();
            }, false);
        }
    }

    handleErrorRequests(errorMessage)
    {
        if (errorMessage !== '')
        {
            displayErrorFeedbackMessage(errorMessage, '', true);
        }
    }

    showOverlay($overlay, selectedItems)
    {
        $overlay.unbind();
        let $body = $('body');
        $overlay.removeClass('hidden');
        $body.addClass('focus-active');

        $body.on('focus-overlay-clicked', () =>
        {
            this.hideOverlay($overlay);
        });
        $overlay.on('click', '.close, .close-overlay', () =>
        {
            this.hideOverlay($overlay);
        });

        $overlay.on('click', '.js-delete-basket-products', () =>
        {
            this.handleDeleteSelectionClick(selectedItems);
            this.hideOverlay($overlay);
        });
    }

    hideOverlay($overlay)
    {
        $overlay.addClass('hidden');
        $('body').removeClass('focus-active');
    }
}

if (document.querySelector('.js-basket') !== null)
{
    (new Cart()).init();
}
